// src/components/About.jsx
import React from 'react';
import '../styles/styles.css';

const About = () => {
  return (
    <section className="about" id="about">
      <h2>About Me</h2>
      <p>
        Hi, I'm Saad — a Frontend Developer specializing in Shopify, WordPress, and Amazon PPC.
        I build responsive e-commerce solutions and manage digital projects with a focus on conversions.
      </p>
    </section>
  );
};

export default About;
